import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from "@angular/router";
import { UsersService } from "@nexu-library/utilities";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(public _usersService: UsersService, private router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let user = this._usersService.getCurrentUser();
    if (!user || !this._usersService.isAuthenticated()) {
      let url = state.url;
      if (state.url.startsWith("/clients/details/") && next?.queryParams?.shared === "true") {
        return true;
      } else if (url != undefined && url != "/") {
        this.router.navigate(["/login"], { queryParams: { returnUrl: url } });
      } else {
        this.router.navigate(["/login"]);
      }
      return false;
    }

    return true;
  }
}
